import { LoadingLazyComponents, NotFoundPage } from "@hoa00/i24-core-ui";
import { FC, lazy } from "react";
import { Route, Routes } from "react-router-dom";

const ListPage = lazy(() => import("./pages/ProductList"));
const Create = lazy(() => import("./pages/ProductCreate"));
const UpdatePage = lazy(() => import("./pages/ProductUpdate"));

const SalesProductRouters: FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<LoadingLazyComponents children={<ListPage />} />}
      />
      <Route
        path="/create"
        element={<LoadingLazyComponents children={<Create />} />}
      />
      <Route
        path="/update/:itemId"
        element={<LoadingLazyComponents children={<UpdatePage />} />}
      />

      {/* Fallback Not found pages */}
      <Route
        path="*"
        element={<LoadingLazyComponents children={<NotFoundPage />} />}
      />
    </Routes>
  );
};

export default SalesProductRouters;
